<template>
	<div>
		<div class="max-w-7xl mx-auto px-6 md:px-0 z-30 relative">

			<div class="mt-12 text-center">
				<span class="tracking-widest text-inter-400 text-sm text-purple-500 uppercase mb-2 block">Our mission</span>
				<h1
					class="font-gilroy-extrabold text-5xl"
					data-aos="fade-down"
					data-aos-duration="1500"
				>World-class quality software<br>tailored for your needs</h1>

				<p class="text-inter-400 text-lg text-gray-500 block mt-12">Codestage is a software development company that develops top-notch and innovative products. <br> We are trusted by big companies to deliver high-quality work on time.</p>

				<router-link
					class="mt-12 block relative max-w-max z-30 mx-auto bg-gradient-to-br from-blue-500 to-purple-700 text-inter-500 hover:scale-105 hue-rotate transition transform duration-500 text-white text-lg rounded-md py-4 px-8 aos-init aos-animate"
					to="/contact"
				>
					Explore our projects
				</router-link>
			</div>

			<div class="mt-20 mx-auto max-w-4xl block gap-8 grid grid-cols-1 md:grid-cols-3">
				<div>
					<div class="flex flex-row justify-center items-center">
						<span class="h-8 w-8 inline-block bg-black text-white text-inter-500 text-lg leading-8 text-center rounded-md">8</span>
						<span class="text-3xl text-black inline-block font-gilroy-extrabold ml-3">Awards</span>
					</div>
					<p class="block text-gray-400 text-inter-500 mt-4 text-center">Our team is composed of former internationally-awarded olympics.</p>
				</div>
				<div>
					<div class="flex flex-row justify-center items-center">
						<span class="h-8 w-8 inline-block bg-black text-white text-inter-500 text-lg leading-8 text-center rounded-md">2</span>
						<span class="text-3xl text-black inline-block font-gilroy-extrabold ml-3">Years</span>
					</div>
					<p class="block text-gray-400 text-inter-500 mt-4 text-center">We have only 2 years on the market, but years of experience behind us.</p>
				</div>
				<div>
					<div class="flex flex-row justify-center items-center">
						<span class="h-8 w-8 inline-block bg-black text-white text-inter-500 text-lg leading-8 text-center rounded-md">5</span>
						<span class="text-3xl text-black inline-block font-gilroy-extrabold ml-3">Countries</span>
					</div>
					<p class="block text-gray-400 text-inter-500 mt-4 text-center">Our software serves users from<br> 🇷🇴, 🇫🇷, 🇪🇸, 🇩🇪 and 🇮🇹</p>
				</div>
			</div>
		</div>

		<div class="mt-20 md:mt-36 px-12 flex h-screen items-center justify-center border-b border-gray-200">
			<div class="w-12/12 md:w-5/12">
				<span class="tracking-widest text-inter-400 text-sm text-purple-500 text-center md:text-left uppercase mb-2 block">Talents</span>
				<h1
					class="font-gilroy-extrabold text-center md:text-left text-4xl md:text-5xl"
					data-aos="fade-down"
					data-aos-duration="1500"
				>Our developers are former<br>internationally-awarded olympics.</h1>

				<p
					data-aos="fade-down"
					data-aos-duration="2000"
					class="text-inter-400 text-justify text-lg max-w-xl text-gray-500 block mt-12"
				> Build and deliver world-class software faster with Codestage's innovative approach. We have a team of former internationally-awarded olympics developers who work on your project from the start to finish, 24/7. </p>

				<router-link
					data-aos="fade-down"
					data-aos-duration="2500"
					class="mt-12 block mx-auto md:ml-0 max-w-max z-30 bg-gradient-to-br from-blue-500 to-purple-700 text-inter-500 hue-rotate transition duration-500 text-white text-lg rounded-md py-4 px-8"
					to="/contact"
				>
					Explore our projects
				</router-link>
			</div>
			<div class="hidden md:block md:w-6/12 -mr-24 ml-12">
				<img class="block mx-auto" src="images/assets/award.png" />
			</div>
		</div>

		<div class="mt-36 px-12 flex h-screen items-center justify-center border-b border-gray-200">
			<div class="hidden md:block md:w-6/12 -ml-24 mr-12">
				<div
					class="rounded-3xl p-7 h-96 bg-cover -ml-80 mr-36 hue-rotate transform rotate-12"
					style='background-image: url("images/gradients/redblue.png");'
				>
					<img
						src="images/assets/banu_antonache.png"
						class="-mt-44 ml-20"
					>
				</div>
			</div>
			<div class="w-12/12 md:w-5/12">
				<span class="tracking-widest text-inter-400 text-sm text-center md:text-left text-purple-500 uppercase mb-2 block">Partners</span>
				<h1
					class="font-gilroy-extrabold text-4xl md:text-5xl text-center md:text-left"
					data-aos="fade-down"
					data-aos-duration="1500"
				>We craft the best products with our experienced partners</h1>

				<p
					data-aos="fade-down"
					data-aos-duration="2000"
					class="text-inter-400 text-justify text-lg max-w-xl text-gray-500 block mt-12"
				> We craft the best software products with our experienced partners from <a
						href="https://ar-studio.net"
						class="text-blue-500"
						target="_blank"
					>AR Studio</a> and <a
						href="https://t2studios.ro"
						class="text-blue-500"
						target="_blank"
					>T2 Studios</a>. Thanks to this model, we can deliver complex projects of any size within a short time frame at very competitive prices. Our team includes developers, project managers, designers and quality assurance engineers who work together closely to meet customer needs in all phases of development - design process, analysis & architecture design as well as implementation.</p>

				<router-link
					data-aos="fade-down"
					data-aos-duration="2500"
					class="mt-12 block relative mx-auto md:ml-0 max-w-max z-30 bg-gradient-to-br from-blue-500 to-purple-700 text-inter-500 hover:scale-105 hue-rotate transition transform duration-500 text-white text-lg rounded-md py-4 px-8 aos-init aos-animate"
					to="/contact"
				>
					Explore our projects
				</router-link>
			</div>
		</div>

		<div class="px-12 h-full bg-black border-b border-gray-200">
			<div class="h-36"></div>
			<span class="tracking-widest text-center text-inter-400 text-sm text-purple-500 uppercasemb-2 block">Frequently Asked Questions</span>
			<h1
				class="font-gilroy-extrabold text-center text-white text-5xl"
				data-aos="fade-down"
				data-aos-duration="1500"
			>Crystal-clear communication</h1>

			<div class="mt-20 grid grid-cols-1 md:grid-cols-3 gap-12">
				<div
					class="relative"
					data-aos="fade-down"
					data-aos-duration="2000"
				>
					<div class="rounded-md z-30 relative">
						<div
							class="text-white flex text-inter-400 p-3 rounded-t-md"
							style="background:#060710"
						>
							<div class="w-2/12">
								<span class="-mt-1 transform rotate-90 block w-3 tracking-widest text-inter-400 text-xs text-purple-500 uppercase">FAQ</span>
							</div>
							<div class="w-10/12 text-right">
								<span class="text-sm">Where are you located?</span>
							</div>
						</div>

						<div>
							<span class="mt-3 text-sm absolute text-inter-400 leading-6 text-center text-white p-3 z-30">Our main office is located in Focsani and our secondary office is located in Bucharest, though we operate globallly. No matter where you're from, Codestage is here for you.</span>
							<div
								class="text-white h-36 rounded-b-md"
								style="background: #000;opacity: .7;"
							>
							</div>
						</div>
					</div>
					<div
						data-aos="fade-down"
						data-aos-duration="3000"
						class="gradient-border z-0"
					></div>
				</div>

				<div
					class="relative"
					data-aos="fade-down"
					data-aos-duration="2500"
				>
					<div class="rounded-md z-30 relative">
						<div
							class="text-white flex text-inter-400 p-3 rounded-t-md"
							style="background:#060710"
						>
							<div class="w-2/12">
								<span class="-mt-1 transform rotate-90 block w-3 tracking-widest text-inter-400 text-xs text-purple-500 uppercase">FAQ</span>
							</div>
							<div class="w-10/12 text-right">
								<span class="text-sm">What do you need to know before starting a project?</span>
							</div>
						</div>

						<div>
							<span class="mt-3 text-sm absolute text-inter-400 leading-6 text-center text-white p-3 z-30">
								We usually need different information or resources for every project, so we will decide these aspects in a kickoff meeting.
							</span>
							<div
								class="text-white h-36 rounded-b-md"
								style="background: #000;opacity: .7;"
							>
							</div>
						</div>
					</div>
					<div
						data-aos="fade-down"
						data-aos-duration="3000"
						class="gradient-border z-0"
					></div>
				</div>

				<div
					class="relative"
					data-aos="fade-down"
					data-aos-duration="3000"
				>
					<div class="rounded-md z-30 relative">
						<div
							class="text-white flex text-inter-400 p-3 rounded-t-md"
							style="background:#060710"
						>
							<div class="w-2/12">
								<span class="-mt-1 transform rotate-90 block w-3 tracking-widest text-inter-400 text-xs text-purple-500 uppercase">FAQ</span>
							</div>
							<div class="w-10/12 text-right">
								<span class="text-sm">Who will take care of my software/web app?</span>
							</div>
						</div>

						<div>
							<span class="mt-3 text-sm absolute text-inter-400 leading-6 text-center text-white p-3 z-30">
								We offer a maintenance subscription that includes development, real-time issue tracking, security monitoring, live intervention & more.
							</span>
							<div
								class="text-white h-36 rounded-b-md"
								style="background: #000;opacity: .7;"
							>
							</div>
						</div>
					</div>
					<div
						data-aos="fade-down"
						data-aos-duration="3000"
						class="gradient-border z-0"
					></div>
				</div>
			</div>
			<div class="h-36"></div>
		</div>
		
		<Contact />

	</div>
</template>

<script>

import Contact from '@/components/Contact'

export default {
	components: {
		Contact
	}
}
</script>